import React from 'react'
import { Box } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'

export default function LegalNotice() {
  return (
    <Box className="w-full py-6 px-4">
      <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3">
        <IconAlertCircle size={18} className="mt-0.5 flex-shrink-0 text-amber-600" />
        <span className="text-xs leading-relaxed text-amber-800">
          我司不提供央行征信和个人爬虫等隐私数据查询,也不提供贷款及信用修复等业务。所有要求你进行汇款、转账、非法刷单、买理财、承诺包下款的操作，都是诈骗！
        </span>
      </div>
    </Box>
  )
}
